/** @jsxRuntime classic */
/** @jsx jsx */
import { LogError } from 'business/constants';
import NewsBlock from 'components/blocks/news-block';
import PageLayout from 'components/ui-components/layout/PageLayout';
import SEO from 'components/utility-wrappers/seo';
import { Fragment, useEffect } from 'react';
import useSWR from 'swr';
import { jsx } from 'theme-ui';
import { changeBgColor } from 'utils/helpers';

const request = {
  params: {},
  query: `{
    'newspage':*[_type == 'newspage' && _id == 'newspage']{
      backgroundcolor,
      headline,
      seo,
      slug,
    }[0],
    'newsposts':*[_type == 'post' && !(_id in path("drafts.**"))] | order(publishedAt desc) {
      title,
      _id,
      slug,
      publishedAt,
      'image': main_image
    }
  }`,
};

export default function News(props) {
  const { data, error } = useSWR([request.query.toString(), request.params]);

  useEffect(() => {
    changeBgColor(data?.newspage?.backgroundcolor || props.color);
  }, [props.color, data]);

  if (error || !data) {
    error && LogError(request.query, request.params, error);
    return null;
  }

  const { newspage = {}, newsposts = {} } = data || {};

  return (
    <Fragment>
      <SEO title={newspage?.headline?.headline} {...newspage?.seo} />
      <PageLayout>
        <NewsBlock
          headline={newspage.headline}
          news={newsposts}
          background={data?.newspage?.backgroundcolor || props.color}
        />
      </PageLayout>
    </Fragment>
  );
}
